import ReactDOM from 'react-dom/client';
import './index.css';
import SpaceShooter from './SpaceShooter';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <SpaceShooter />
);